import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/30 bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-172" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-173" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-174" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-175" data-mp="39gb4cs8pe88j">Does This Sound <span className="text-accent" data-id="element-176" data-mp="35gki91u4ggac">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-177" data-mp="35idf5pexnm55">
            You're working with chemical processes and industrial production but struggle with gaps in technical
            understanding. When colleagues ask about chemical reactions, equipment operation, process control, production
            efficiency, or troubleshooting problems, you can't confidently explain the technical reasons.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/60 border-t-accent/50 bg-surface p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-178" data-mp="je6daslis85r">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-foreground" data-id="element-179" data-mp="123v2e52owud7">
            <AlertTriangleIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-180" data-mp="1726b2ch90ytu" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-181" data-mp="1c33tmq667uvv">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-182" data-mp="1g3w23h77xvr3">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-accent" aria-hidden="true" data-id="element-183" data-mp="3dtfdchxerzwh" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-184" data-mp="p090hpuyd6e0">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-185" data-mp="p1bpfs8psyra">
            Stop wasting personal time. You're already experienced. What you need is the right tool.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-accent sm:text-3xl" data-id="element-186" data-mp="y2050rdrb76a">Build your entire industrial chemistry knowledge today.</p>
        </div>
      </div>
    </section>;
}